/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

import { MobH2Style, TextRegStyle } from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';

export const Contacts = () => {
  return (
    <SCContacts itemScope itemType="https://schema.org/LocalBusiness">
      <SCTitle>
        Контакты
      </SCTitle>
      <SCItemTitle>
        Поддержка авторов и читателей
      </SCItemTitle>
      <SCItemWrapper>
        <SCItemText>
          Если вам нужна помощь при работе с Букривер, посмотрите
          ответы на вопросы и видео-инструкции в
          <SCLink>
            нашей базе.
          </SCLink>
        </SCItemText>
        <SCItemText>
          По техническим, финансовым вопросам, а также всем вопросам,
          связанным с интеллектуальными правами, пишите в службу
          поддержки:
          {' '}
          <SCLink
            href="mailto:support@bookriver.ru"
          >
            support@bookriver.ru
          </SCLink>
        </SCItemText>
      </SCItemWrapper>
      <SCItemWrapper>
        <SCItemTitle>
          Реквизиты
        </SCItemTitle>
        <SCItemText>
          ИП Черкасов С.В.
        </SCItemText>
        <SCItemText>
          ОГРНИП:307673114500020
        </SCItemText>
        <SCItemText>
          ИНН:673110673051
        </SCItemText>
      </SCItemWrapper>
      <SCItemWrapper>
        <SCItemTitle>
          Адрес
        </SCItemTitle>
        <SCItemText itemProp="address">
          г. Смоленск, ул. Дохтурова, д. 3А
        </SCItemText>
        <SCMap>
          {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A3b2b2e98430ca27aabb98b5e85c7df27e06ba27391ef26c4b72d5bbf95a8e823&amp;source=constructor"
            width="500"
            height="249"
            frameBorder="0"
          />
        </SCMap>
      </SCItemWrapper>
    </SCContacts>
  );
};

const SCContacts = styled.div`
  background: #FFFFFF;
  padding: 16px 36px;
  margin: 30px 0;

  ${lessThan('sm')} {
    padding: 12px 20px;
    margin: 20px 0;
  }
`;

const SCTitle = styled.h1`
  font-family: var(--main-font);
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: var(--black-color);
  margin-bottom: 30px;
`;

const SCItemTitle = styled.h3`
  ${MobH2Style};
  margin-bottom: 10px;
  color: var(--black-color);
`;

const SCItemWrapper = styled.div`
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
`;

const SCItemText = styled.span`
  ${TextRegStyle};
  color: var(--black-color);
  display: inline-block;
`;

const SCLink = styled.a`
  color: var(--primary-color);
  font-weight: inherit;
  font-family: inherit;
  line-height: inherit;
  font-size: inherit;
  transition: color 0.3s ease;
  padding-left: 3px;
  
  &:hover {
    color: var(--primary-hover-color);
  }
`;

const SCMap = styled.div`
  margin-top: 12px;
  max-width: 430px;
`;
